import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

const AudioPlayer = ({ title, speaker, duration, description, src = null, dark = false, index = 0 }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [notice, setNotice] = useState(false);

  const toggle = () => {
    if (!src) {
      setNotice(true);
      setTimeout(() => setNotice(false), 2600);
      return;
    }
    if (playing) {
      audioRef.current?.pause();
    } else {
      audioRef.current?.play();
    }
    setPlaying(!playing);
  };

  const base = dark ? "border-creme/15 text-creme" : "border-sand text-ink";
  const sub = dark ? "text-creme/60" : "text-stone";

  return (
    <div
      data-testid={`audio-player-${index}`}
      className={`group flex items-center gap-5 border-b py-6 transition-colors ${base} ${
        dark ? "hover:border-sand/50" : "hover:border-rust/50"
      }`}
    >
      {src && <audio ref={audioRef} src={src} onEnded={() => setPlaying(false)} preload="none" />}
      <button
        onClick={toggle}
        data-testid={`audio-play-button-${index}`}
        aria-label={playing ? `${title} pausieren` : `${title} abspielen`}
        className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
          dark
            ? "border-creme/30 group-hover:border-sand group-hover:bg-sand group-hover:text-mossdeep"
            : "border-ink/25 group-hover:border-moss group-hover:bg-moss group-hover:text-creme"
        }`}
      >
        {playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-4">
          <h3 className="font-serif text-xl">{title}</h3>
          <span className={`text-xs font-semibold uppercase tracking-[0.2em] ${sub}`}>{speaker}</span>
        </div>
        <p className={`mt-1 text-sm ${sub}`}>{description}</p>
        <div className="mt-3 flex items-center gap-3">
          <div className={`flex h-4 items-end gap-[3px] ${playing ? "" : "opacity-40"}`}>
            {[0, 1, 2, 3, 4, 5, 6].map((b) => (
              <span
                key={b}
                className={`eq-bar w-[3px] rounded-full ${dark ? "bg-sand" : "bg-moss"}`}
                style={{
                  height: `${8 + ((b * 5) % 9)}px`,
                  animationDelay: `${b * 0.11}s`,
                  animationPlayState: playing ? "running" : "paused",
                }}
              />
            ))}
          </div>
          <span className={`text-xs tabular-nums ${sub}`}>{duration} Min.</span>
          {notice && (
            <span data-testid={`audio-notice-${index}`} className={`text-xs italic ${dark ? "text-sand" : "text-rust"}`}>
              Aufnahme folgt in Kürze
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;
